import Lookup from 'src/componentes/select2';

const ClassificacaoLookup = ({ multi = true, ...rest }) => (
  <Lookup
    labelKey="descricao"
    valueKey="id"
    multi={multi}
    url="/ClassificacaoLookup"
    {...rest}
  />
);

export default ClassificacaoLookup;
